export default function isFunction(test: any): boolean {
  return typeof test === 'function';
}
